import { render, staticRenderFns } from "./test-result.vue?vue&type=template&id=16826f3c&"
import script from "./test-result.vue?vue&type=script&lang=js&"
export * from "./test-result.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports